module.exports = __webpack_public_path__ + "front/img/content2.ea033ee2.png";